import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-logout',
  template: `
    <overlay-loading></overlay-loading>`,
  providers: [],
})

export class LogoutComponent {

  constructor(
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
  ) {
    const nextParam = activeRoute.snapshot.queryParams.next;
    this.authService.logout(nextParam);
  }
}
